import React from 'react';
import DataTable from 'react-data-table-component';
import i18n from '../../../../i18n';
import { SideBar } from '../../sidebar';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import StatusTabs from '../../../common/StatusTab';
import HeaderBanner from '../../../common/HeaderBanner';
import { getVehiclesList } from './services/VehicleListService';
import { verifyVehicleDetails } from '../VehicleRegistration/services/VehicleDetailsService';
import { Truck, Check, Eye, BadgeAlert, Copy, User } from 'lucide-react';
import { Link } from 'react-router-dom';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import { ConfirmModal } from '../../../common/ConfirmModal'; // Import ConfirmModal
import { toast } from 'react-toastify';

// Constants
const VEHICLE_STATUS_ACTIVE = 'A';
const VEHICLE_STATUS_PENDING = 'P';
const VEHICLE_STATUS_REJECTED = 'R';

const vehicleStatusMap = {
  [VEHICLE_STATUS_ACTIVE]: { label: 'Active', color: '#10b981' },
  [VEHICLE_STATUS_PENDING]: { label: 'Pending', color: '#f59e0b' },
  [VEHICLE_STATUS_REJECTED]: { label: 'Rejected', color: '#ef4444' }
};

export class VehicleList extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        group: '',
        auction: '',
        status: '',
        bidder: null,
      },
      vehiclesStatus: 'all',
      input: {},
      groups: [],
      auctions: [],
      customers: [],
      vehicles: [],
      selectedUser: {},
      showUserPopUp: false,
      statusData: [
        { label: 'All', count: 0 },
        { key: 'active', label: 'Active', count: 0 },
        { key: 'expired', label: 'Expired', count: 0 },
      ],
      is_loading: false,
      limit: 15,
      page: 1,
      rejectNote: null,
      rejectNoteError: null,
      hideSidebar: false,
      showModal: false,
      processingId: null,
      copiedId: null,

      // Modal states
      showConfirmModal: false,
      currentAction: null, // 'approve' or 'reject'
      currentVehicle: null,
      rejectionReason: '',
      showRejectionReasonModal: false,
      showSuccessModal: false,
      successMessage: '',
      showErrorModal: false,
      errorMessage: ''
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const params = new URLSearchParams(window.location.search);
    const search = {
      group: params.get('group') || '',
      auction: params.get('auction') || '',
      status: params.get('status') || '',
      bidder: params.get('bidder') || null,
    };
    const vehiclesStatus = params.get('vehiclesStatus');
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ search, vehiclesStatus, page, limit }, () => {
      this.getAllGroups?.();
      this.getVehicles();
    });
  }

  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }

  async getVehicles() {
    this.setState({ is_loading: true });
    let { limit, page, vehiclesStatus } = this.state;

    const statusMap = {
      'active': 'A',
      'reject': 'R',
      'all': 'all',
      'P': 'P'
    };

    const backendStatus = vehiclesStatus !== 'all' ?
      (statusMap[vehiclesStatus] || vehiclesStatus) : 'all';

    const filters = {
      status: backendStatus !== 'all' ? backendStatus : undefined,
      page: page,
      per_page: limit
    };

    console.log('Fetching vehicles with filters:', filters);

    const response = await getVehiclesList(filters);

    console.log("API Response:", response);

    if (response && response.success) {
      let vehicles = response.data || [];
      let pagination = response.pagination;
      let meta = response.meta;

      this.setState({
        vehicles: vehicles || [],
        total: pagination?.total || vehicles?.length || 0,
        currentPage: pagination?.current_page || page,
        perPage: pagination?.per_page || limit,
        totalPages: pagination?.last_page || 1,
        statusData: [
          {
            key: 'all',
            label: 'All',
            count: meta?.total || pagination?.total || vehicles?.length || 0
          },
          {
            key: 'active',
            label: 'Active',
            count: meta?.active || 0
          },
          {
            key: 'reject',
            label: 'Reject',
            count: meta?.expired || 0
          },
          {
            key: 'P',
            label: 'Pending',
            count: meta?.pending || 0
          },
        ],
        is_loading: false,
      });
    } else {
      console.error('Failed to fetch vehicles:', response?.message);
      this.setState({
        vehicles: [],
        is_loading: false
      });
    }
  }

  handleTabChange = (key) => {
    this.setState({ vehiclesStatus: key }, () => {
      this.getVehicles();
    });
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.getVehicles();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.getVehicles();
    });
  };

  handlePageChange = (page) => {
    this.onChangePage(page);
  };

  handleRowsPerPageChange = (newLimit, page) => {
    this.onChangeRowsPerPage(newLimit);
  };

  handleRowClick = (row, e) => {
    console.log('Row clicked:', row);

    if (this.props.history && row.id) {
      this.props.history.push(`/vehicle/${row.id}/edit`);
    }
  };

  handleApprove = (row, e) => {
    e?.stopPropagation();

    this.setState({
      showConfirmModal: true,
      currentAction: 'approve',
      currentVehicle: row,
      modalTitle: 'Approve Vehicle',
      modalMessage: `Are you sure you want to approve vehicle ${row.vehicle_number}?`,
      confirmButtonVariant: 'success'
    });
  };

  handleReject = (row, e) => {
    e?.stopPropagation();

    this.setState({
      showRejectionReasonModal: true,
      currentVehicle: row,
      rejectionReason: ''
    });
  };

  confirmApprove = async () => {
    const { currentVehicle } = this.state;

    if (!currentVehicle) return;

    this.setState({
      showConfirmModal: false,
      processingId: currentVehicle.id
    });

    try {
      const result = await verifyVehicleDetails(currentVehicle.id, VEHICLE_STATUS_ACTIVE);

      if (result.success) {
        this.setState({
          showSuccessModal: true,
          successMessage: 'Vehicle approved successfully!'
        });

        // Refresh data after delay
        setTimeout(() => {
          this.getVehicles();
        }, 1500);
      } else {
        this.setState({
          showErrorModal: true,
          errorMessage: result.message || 'Failed to approve vehicle'
        });
      }

    } catch (error) {
      console.error('Error approving vehicle:', error);
      this.setState({
        showErrorModal: true,
        errorMessage: error.response?.data?.message || error.message || 'Failed to approve vehicle'
      });
    } finally {
      this.setState({
        processingId: null,
        currentVehicle: null
      });
    }
  };

  submitRejection = () => {
    const { currentVehicle, rejectionReason } = this.state;

    if (!rejectionReason.trim()) {
      this.setState({
        showErrorModal: true,
        errorMessage: 'Rejection reason is required'
      });
      return;
    }

    this.setState({
      showRejectionReasonModal: false,
      showConfirmModal: true,
      currentAction: 'reject',
      modalTitle: 'Reject Vehicle',
      modalMessage: `Are you sure you want to reject vehicle ${currentVehicle.vehicle_number}?`,
      confirmButtonVariant: 'danger'
    });
  };

  confirmReject = async () => {
    const { currentVehicle } = this.state;

    if (!currentVehicle) return;

    this.setState({
      showConfirmModal: false,
      processingId: currentVehicle.id
    });

    try {
      // For reject, you might need to pass rejection reason
      // Adjust verifyVehicleDetails if needed for rejection reason
      const result = await verifyVehicleDetails(currentVehicle.id, VEHICLE_STATUS_REJECTED);

      if (result.success) {
        this.setState({
          showSuccessModal: true,
          successMessage: 'Vehicle rejected successfully!'
        });

        // Refresh data after delay
        setTimeout(() => {
          this.getVehicles();
        }, 1500);
      } else {
        this.setState({
          showErrorModal: true,
          errorMessage: result.message || 'Failed to reject vehicle'
        });
      }

    } catch (error) {
      console.error('Error rejecting vehicle:', error);
      this.setState({
        showErrorModal: true,
        errorMessage: error.response?.data?.message || error.message || 'Failed to reject vehicle'
      });
    } finally {
      this.setState({
        processingId: null,
        currentVehicle: null,
        rejectionReason: ''
      });
    }
  };

  closeModals = () => {
    this.setState({
      showConfirmModal: false,
      showRejectionReasonModal: false,
      showSuccessModal: false,
      showErrorModal: false,
      currentVehicle: null,
      currentAction: null,
      rejectionReason: '',
      successMessage: '',
      errorMessage: ''
    });
  };

  getColumns() {
    const { processingId } = this.state;

    return [
      {
        name: 'ID',
        selector: row => row.id,
        sortable: true,
        width: '80px'
      },
      {
        name: 'Vehicle No',
        selector: row => row.vehicle_number,
        sortable: true,
        cell: row => (
          <div>
          <div style={{ fontWeight: '600', color: '#1e40af' }}>
            {row.vehicle_number}
          </div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>{row.vehicle_model}</div>
          </div>
        ),
      },
      {
        name: 'Type',
        selector: row => row.vehicle_type?.name || row.vehicle_type_id || 'N/A',
        sortable: true,
        cell: row => (
          <div>
            {row.vehicle_type?.name || `Type #${row.vehicle_type_id}`}
          </div>
        ),
      },
      {
        name: 'OPAL',
        selector: row => row.opal,
        width: '100px',
        cell: row => (
          <span
            style={{
              backgroundColor: row.opal === true ? '#dbeafe' : '#f0f9ff',
              color: row.opal === true ? '#1e40af' : '#0369a1',
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: '12px',
              fontWeight: '500',
            }}
          >
            {row.opal === true ? 'OPAL' : 'Non-OPAL'}
          </span>
        ),
      },
      {
        name: 'Driver',
        cell: row => (
          <div style={{  width:'130px'}}>
            <div>
              <div style={{ fontWeight: '500' }}>{row.driver.name}</div>
              <div style={{ fontSize: '12px', color: '#6b7280' }}>{row.driver.phone}</div>
            </div>
          </div>
        ),
        sortable: true,
        sortFunction: (a, b) => a.name.localeCompare(b.name)
      },
      {
        name: 'Status',
        selector: row => row.status,
        sortable: true,
        cell: row => {
          const status = vehicleStatusMap[row.status] || { label: row.status, color: '#6b7280' };
          return (
            <span
              style={{
                backgroundColor: `${status.color}15`,
                color: status.color,
                padding: '4px 12px',
                borderRadius: '0.3rem',
                fontSize: '12px',
                fontWeight: '500'
              }}
            >
              {status.label}
            </span>
          );
        }
      },
      {
        name: 'Actions',
        width: '160px',
        center: true,
        cell: (row) => (
          <div className="d-flex align-items-center justify-content-center gap-2">
            <Link
              className="btn-new btn-sm"
              to={`/vehicle/${row.id}/edit`}
              onClick={(e) => e.stopPropagation()}
              style={{
                backgroundColor: '#f3f4f6',
                color: '#374151',
                border: '1px solid #d1d5db'
              }}
              title="View Details"
            >
              <Eye size={14} />
            </Link>

            <button
              className="btn-new btn-sm"
              onClick={(e) => this.handleApprove(row, e)}
              disabled={processingId === row.id || row.status === VEHICLE_STATUS_ACTIVE}
              title="Approve"
              style={{
                backgroundColor: row.status === VEHICLE_STATUS_ACTIVE ? '#d1fae5' : '#f0f9ff',
                color: row.status === VEHICLE_STATUS_ACTIVE ? '#065f46' : '#0369a1',
                border: '1px solid #d1fae5',
                opacity: processingId === row.id ? 0.5 : 1,
                cursor: processingId === row.id || row.status === VEHICLE_STATUS_ACTIVE ? 'not-allowed' : 'pointer'
              }}
            >
              {processingId === row.id ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                <Check size={14} />
              )}
            </button>

            <button
              className="btn-new btn-sm"
              onClick={(e) => this.handleReject(row, e)}
              disabled={processingId === row.id || row.status === VEHICLE_STATUS_REJECTED}
              title="Reject"
              style={{
                backgroundColor: row.status === VEHICLE_STATUS_REJECTED ? '#fee2e2' : '#fef3c7',
                color: row.status === VEHICLE_STATUS_REJECTED ? '#dc2626' : '#d97706',
                border: '1px solid #fef3c7',
                opacity: processingId === row.id ? 0.5 : 1,
                cursor: processingId === row.id || row.status === VEHICLE_STATUS_REJECTED ? 'not-allowed' : 'pointer'
              }}
            >
              {processingId === row.id ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                <BadgeAlert size={14} />
              )}
            </button>
          </div>
        ),
      },
    ];
  }

  renderVehicleTable() {
    const { vehicles = [], page = 1, limit = 15, total = 0, is_loading } = this.state;

    const customTableStyles = {
      ...tableStyles,
      rows: {
        ...tableStyles.rows,
        style: {
          ...tableStyles.rows?.style,
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: '#f8f9fa',
          },
        },
      },
    };

    if (is_loading) {
      return <TableSkeleton columns={8} rows={10} />;
    }

    return (
      <DataTable
        key={`${page}-${limit}`}
        title=""
        columns={this.getColumns()}
        data={vehicles}
        customStyles={customTableStyles}
        highlightOnHover
        pagination
        paginationServer
        paginationTotalRows={total}
        paginationPerPage={limit}
        paginationDefaultPage={page}
        paginationRowsPerPageOptions={[15, 25, 50, 100]}
        paginationComponentOptions={{
          rowsPerPageText: i18n.t('rows_per_page'),
          rangeSeparatorText: i18n.t('out'),
        }}
        onChangeRowsPerPage={this.handleRowsPerPageChange}
        onChangePage={this.handlePageChange}
        onRowClicked={this.handleRowClick}
      />
    );
  }

  render() {
    const {
      hideSidebar,
      vehicles,
      is_loading,
      vehiclesStatus,
      statusData,
      showConfirmModal,
      showRejectionReasonModal,
      showSuccessModal,
      showErrorModal,
      modalTitle,
      modalMessage,
      confirmButtonVariant,
      currentAction,
      rejectionReason,
      successMessage,
      errorMessage,
      processingId
    } = this.state;

    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t('vehicle_list')}
          subtitle={i18n.t('manage_vehicle_list')}
        />
        <section className="mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!hideSidebar && <SideBar />}
              </div>

              <div
                className={
                  hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !hideSidebar,
                          });
                        }}
                      >
                        {hideSidebar && <i className="icon-size-actual"></i>}
                        {!hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>



                    <div className="expand-dashboard" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <button
                          className="btn-new btn-sm"
                          style={{
                            backgroundColor: '#f3f4f6',
                            color: '#374151',
                            border: '1px solid #d1d5db',
                            padding: '5px 10px',
                            fontSize: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px'
                          }}
                          onClick={() => {
                            const url = window.location.origin + '/site-pass-request';
                            navigator.clipboard.writeText(url)
                              .then(() => {
                                toast.success('Link copied to clipboard!');
                              })
                              .catch(err => {
                                console.error('Failed to copy link: ', err);
                                toast.error('Failed to copy link');
                              });
                          }}
                          title="Copy bulk registration link"

                        >
                          <Copy size={14} /> Copy Link
                        </button>
                        <Link to="/site-pass-request" className='button1 button1-primary'>
                          <Truck /> {i18n.t('bulk_vehicle_reg')}
                        </Link>

                      </div>
                      {/* <div>
                        <Link to="/vehicle-registration" className='button1 button1-primary'>
                          <Truck /> {i18n.t('vehicle_registration')}
                        </Link>
                      </div> */}
                    </div>


                  </div>

                  <div className="card-body">
                    <StatusTabs
                      tabs={statusData}
                      onTabChange={this.handleTabChange}
                      selected={vehiclesStatus}
                    />

                    <div className="Data-Listing">
                      {is_loading ? (
                        <TableSkeleton columns={8} rows={10} />
                      ) : vehicles.length ? (
                        this.renderVehicleTable()
                      ) : (
                        <NoData
                          message="No vehicles available"
                          actionText="Refresh"
                          onAction={this.getVehicles.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Confirm Modal for Approve/Reject */}
        <ConfirmModal
          show={showConfirmModal}
          onClose={this.closeModals}
          title={modalTitle}
          message={modalMessage}
          onConfirm={currentAction === 'approve' ? this.confirmApprove : this.confirmReject}
          confirmText={currentAction === 'approve' ? 'Approve' : 'Reject'}
          cancelText="Cancel"
          loading={processingId !== null}
          type="confirm"
          confirmButtonVariant={confirmButtonVariant}
        />

        {/* Rejection Reason Modal */}
        <ConfirmModal
          show={showRejectionReasonModal}
          onClose={this.closeModals}
          title="Rejection Reason"
          onConfirm={this.submitRejection}
          confirmText="Continue"
          cancelText="Cancel"
          closeBtn={false}
        >
          <div className="mb-3">
            <label htmlFor="rejectionReason" className="form-label">
              Please enter rejection reason:
            </label>
            <textarea
              id="rejectionReason"
              className="form-control"
              rows="3"
              value={rejectionReason}
              onChange={(e) => this.setState({ rejectionReason: e.target.value })}
              placeholder="Enter reason for rejection..."
            />
          </div>
        </ConfirmModal>

        {/* Success Modal */}
        <ConfirmModal
          show={showSuccessModal}
          onClose={this.closeModals}
          title="Success"
          message={successMessage}
          onConfirm={this.closeModals}
          confirmText="OK"
          cancelText={null}
          type="success"
          confirmButtonVariant="success"
        />

        {/* Error Modal */}
        <ConfirmModal
          show={showErrorModal}
          onClose={this.closeModals}
          title="Error"
          message={errorMessage}
          onConfirm={this.closeModals}
          confirmText="OK"
          cancelText={null}
          type="error"
          confirmButtonVariant="danger"
        />
      </React.Fragment>
    );
  }
}